import React from 'react';
import Timestamp from '../../../Timestamp';
import UserAvatar from '../../../User/Avatar';
import BasicUserName from '../../../User/BasicUserName';
import UserLink from '../../../User/Link';
import s from './FooterPanel.scss';
export const FOOTER_PANEL_HEIGHT = parseInt(s['footer-panel-height'], 10);
const FooterPanel = ({ deviation, withAuthorLink = true })=>{
    const author = deviation.author && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: deviation.author,
        size: 24,
        className: s['avatar'],
        withLink: false
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['username']
    }, /*#__PURE__*/ React.createElement(BasicUserName, {
        user: deviation.author
    })));
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, deviation.author && (withAuthorLink ? /*#__PURE__*/ React.createElement(UserLink, {
        user: deviation.author,
        className: s['author']
    }, author) : /*#__PURE__*/ React.createElement("span", {
        className: s['author']
    }, author)), /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: deviation.publishedTime,
        className: s['timestamp']
    }));
};
FooterPanel.displayName = 'FooterPanel';
export default FooterPanel;
